import Vue from 'vue';
import { ButtonPlugin, SpinnerPlugin } from 'bootstrap-vue';
import router from './router';
import store from './store';
import { rebindFormValidation } from './utils';
import useValidationClassesDirective from './directives/validation-classes';
import useBs4TooltipDirective from './directives/bs4-tooltip';
import useFocusOnShowDirective from './directives/focus-on-show';

useValidationClassesDirective();
useBs4TooltipDirective();
useFocusOnShowDirective();

Vue.use(ButtonPlugin);
Vue.use(SpinnerPlugin);

new Vue({
    router,
    store,
    mounted: rebindFormValidation,
    updated: rebindFormValidation
}).$mount('#app');